import React from "react";
import { PropTypes } from "prop-types";
import { Button, Header, Icon, Segment } from "semantic-ui-react";
import { getLatestDeclinedPublishedRequest } from "./tools";

const stateDescriptions = {
  validated: {
    label: "Quality checks passed",
    description:
      "All automatically run quality checks have passed. Now you are able to request for publication.",
  },
  error: {
    label: "Quality checks failed",
    description:
      "Some automatically run quality checks have failed. Please check the logs and fix the errors before requesting for publication.",
  },
  draft: {
    label: "Preparation",
    description:
      "Draft is being prepared. You can add files and metadata to the asset record.",
  },
  submitted: {
    label: "Requested for publication",
    description:
      "Record is in the process of being reviewed by the owners. After the review, the request for publish will be accepted or declined.",
  },
  running: {
    label: "Being checked by the system",
    description:
      "Record's data and metadata are being automatically checked by the quality pipelines.",
  },
  declined: {
    label: "Publication request declined",
    description:
      "Record's publication request was declined by the owners. You can fix the issues and request for publication again.",
  },
};

export const StateDisplay = ({ state, requests }) => {
  let declinedPublishedRequest = null;
  if (state === "declined") {
    declinedPublishedRequest = getLatestDeclinedPublishedRequest(requests);
  }
  return (
    <Segment>
      <Header color="orange" as="h5">
        {stateDescriptions[state]?.label || state}
      </Header>
      <p>
        {stateDescriptions[state]?.description || "No description available."}
      </p>
      {declinedPublishedRequest && (
        <Button
          basic
          negative
          as={"a"}
          href={declinedPublishedRequest.links.self_html}
        >
          <Icon name="external"></Icon>
          Declined Publication Detail
        </Button>
      )}
    </Segment>
  );
};

StateDisplay.propTypes = {
  state: PropTypes.string.isRequired,
  requests: PropTypes.array.isRequired,
};
